import { render } from "./CadastroRevisao.vue?vue&type=template&id=4a7d45e6"
import script from "./CadastroRevisao.vue?vue&type=script&lang=js"
export * from "./CadastroRevisao.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__